import { Rect, Circle, Group, Line } from 'react-konva';
import PropTypes from 'prop-types';
import React from 'react';
import annTools from './commonAnnotationTools';
const selectColor = 'rgb(22,114,84)';

// must be defined outside of the component to avoid re-rendering loops
const defaultOnDragMove = () => {};
const defaultBox = {};
const defaultEnds = [];
const Annotation = ({
  selectedID,
  annotationID,
  children,
  onDragEnd,
  onDragMove: _onDragMove = defaultOnDragMove,
  draggable: _draggable = false,
  box: _box = defaultBox,
  hideSelectionBox: _hideSelectionBox = false,
  scalable: _scalable = false,
  scale,
  ends: _ends = defaultEnds,
  dpiScale: _dpiScale = 1
}) => {
  const isSelected = selectedID === annotationID;
  const pixelOffset = annTools.selectionOffset * scale / _dpiScale;
  const adjustX = (_box.x - pixelOffset) / _dpiScale;
  const adjustY = (_box.y - pixelOffset) / _dpiScale;
  const adjustW = (_box.w + 2 * pixelOffset) / _dpiScale;
  const adjustH = (_box.h + 2 * pixelOffset) / _dpiScale;
  let cornerAnchors = [];
  if (isSelected && _scalable) {
    if (_ends && _ends.length) {
      cornerAnchors = [{
        x: _ends[0][0],
        y: _ends[0][1],
        key: 'beginning'
      }, {
        x: _ends[1][0],
        y: _ends[1][1],
        key: 'end'
      }];
    } else {
      cornerAnchors = [{
        x: adjustX,
        y: adjustY,
        key: 'ul'
      }, {
        x: adjustX + adjustW,
        y: adjustY,
        key: 'ur'
      }, {
        x: adjustX + adjustW,
        y: adjustY + adjustH,
        key: 'lr'
      }, {
        x: adjustX,
        y: adjustY + adjustH,
        key: 'll'
      }];
    }
  }
  const largeCircleDiameter = 15 * scale / _dpiScale;
  const smallCircleDiameter = 20 / _dpiScale; // don't scale selection knobs with zoom

  const endSelect = cornerAnchors.length === 2;
  const circleDiameter = endSelect ? largeCircleDiameter : smallCircleDiameter;
  return /*#__PURE__*/React.createElement(Group, {
    draggable: isSelected && _draggable,
    name: annotationID,
    onDragEnd: onDragEnd
  }, endSelect ? /*#__PURE__*/React.createElement(Line, {
    key: `${annotationID}-selection-tube`,
    points: [cornerAnchors[0].x, cornerAnchors[0].y, cornerAnchors[1].x, cornerAnchors[1].y],
    stroke: selectColor,
    strokeWidth: 40 * scale,
    opacity: 0.1,
    lineCap: "round"
  }) : null, children, isSelected && !_hideSelectionBox && !endSelect ? /*#__PURE__*/React.createElement(Rect, {
    x: adjustX,
    y: adjustY,
    width: adjustW,
    height: adjustH,
    strokeWidth: 4,
    stroke: selectColor
  }) : null, cornerAnchors.map(next => /*#__PURE__*/React.createElement(Circle, {
    draggable: isSelected && _draggable,
    onDragMove: _onDragMove,
    key: `${next.key}-knob`,
    name: next.key,
    x: next.x,
    y: next.y,
    width: circleDiameter,
    height: circleDiameter,
    fill: selectColor
  })));
};
Annotation.propTypes = {
  annotationID: PropTypes.string.isRequired,
  box: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
    h: PropTypes.number,
    w: PropTypes.number
  }),
  ends: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  children: PropTypes.node.isRequired,
  onDragMove: PropTypes.func,
  draggable: PropTypes.bool,
  hideSelectionBox: PropTypes.bool,
  onDragEnd: PropTypes.func.isRequired,
  scalable: PropTypes.bool,
  selectedID: PropTypes.string.isRequired,
  scale: PropTypes.number.isRequired,
  dpiScale: PropTypes.number
};
export default Annotation;